import { Injectable } from '@angular/core';
import { Headers, Http, URLSearchParams } from '@angular/http';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import 'rxjs/add/operator/map';
import { AppConstants } from '../core/app.constants';
import { BaseResponse, OffersResponse, Offer } from "../core/core.component";
import { SelectItem } from 'primeng/primeng';
import { of } from 'rxjs/observable/of';

@Injectable()
export class OfferService {

    constructor(private http: Http) { }

    getOffers(srmToken: string, onlyActive: boolean, idcliente?: number,
        tipologia?: string,
        dtinizio?: Date,
        dtfine?: Date,
        idutente?: number,
        reforder?: string,
        dora?: string,
        cdr?: string):
        Observable<OffersResponse> {
        var url = environment.REST_SERVICE_BASE_URL + "/offers";
        url = AppConstants.urlForNoCache(url);
        var headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
        headers.append('Content-Type', 'application/json');
        const formattedDtinizio = this.formatDateToISO(dtinizio);
        const formattedDtfine = this.formatDateToISO(dtfine);
        let body = {
            onlyActive: onlyActive,
            idcliente: idcliente,
            dtinizio: formattedDtinizio,
            dtfine: formattedDtfine,
            tipologia: tipologia,
            idutente: idutente,
            refOrder: reforder,
            dora: dora,
            cdr: cdr
        };

        return this.http.post(url, JSON.stringify(body), { headers: headers }).map((responseData) => responseData.json());
    }

    insertOffer(srmToken, offer: Offer): Observable<BaseResponse> {
        console.log(offer);
        var url = environment.REST_SERVICE_BASE_URL + "/offers/insert";
        url = AppConstants.urlForNoCache(url);
        var headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
        headers.append('Content-Type', 'application/json');
        const formattedDtinizio = this.formatDateToISO(offer.dtinizio);
        const formattedDtfine = this.formatDateToISO(offer.dtfine);
        const formattedDtAccettaz = this.formatDateToISO(offer.dtaccettaz);
        let body = {
            reforder: offer.reforder,
            dsofferta: offer.dsofferta,
            idcliente: offer.idcliente,
            dtinizio: formattedDtinizio,
            dtfine: formattedDtfine,
            importo: offer.importo,
            tipologia: offer.tipologia,
            giornate: offer.giornate,
            reforder_EXT: offer.reforder_EXT,
            dtaccettaz: formattedDtAccettaz,
            note: offer.note,
            dora: offer.dora,
            cdr: offer.cdr,
            linkDocu: offer.linkdocu
        };

        return this.http.post(url, JSON.stringify(body), { headers: headers }).map((responseData) => responseData.json());
    }

    updateOffer(srmToken, offer: Offer): Observable<BaseResponse> {
        var url = environment.REST_SERVICE_BASE_URL + '/offers/update/' + offer.reforder;
        url = AppConstants.urlForNoCache(url);
        var headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
        const formattedDtinizio = this.formatDateToISO(offer.dtinizio);
        const formattedDtfine = this.formatDateToISO(offer.dtfine);
        const formattedDtAccettaz = this.formatDateToISO(offer.dtaccettaz);
        let body = {
            reforder: offer.reforder,
            dsofferta: offer.dsofferta,
            idcliente: offer.idcliente,
            dtinizio: formattedDtinizio,
            dtfine: formattedDtfine,
            importo: offer.importo,
            tipologia: offer.tipologia,
            giornate: offer.giornate,
            reforder_EXT: offer.reforder_EXT,
            dtaccettaz: formattedDtAccettaz,
            note: offer.note,
            dora: offer.dora,
            cdr: offer.cdr,
            linkDocu: offer.linkdocu
        };

        return this.http.put(url, body, { headers: headers }).map((responseData) => responseData.json());
    }

    private formatDateToISO(date: Date): string {
        if (!date) return '';
        const newDate = new Date(date);
        newDate.setDate(newDate.getDate() + 1);
        return newDate.toISOString();
    }

    deleteOffer(srmToken, id: string): Observable<BaseResponse> {
        let url = environment.REST_SERVICE_BASE_URL + '/offers/delete/' + id;
        url = AppConstants.urlForNoCache(url);
        const headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
        return this.http.delete(url, { headers: headers }).map((responseData) => responseData.json());
    }

    getOfferteUtenti(srmToken: string, reforder: string): Observable<BaseResponse> {
        var url = environment.REST_SERVICE_BASE_URL + "/offers/utenti";
        url = AppConstants.urlForNoCache(url);
        var headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
        let params: URLSearchParams = new URLSearchParams();
        params.set("reforder", reforder);
        return this.http.get(url, { search: params, headers: headers }).map((responseData) => responseData.json());
    }

    insertUser(srmToken: string, user: SelectItem): Observable<BaseResponse> {
        var url = environment.REST_SERVICE_BASE_URL + "/offers/insertuser";
        url = AppConstants.urlForNoCache(url);
        var headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
        headers.append('Content-Type', 'application/json');

        let body = {
            reforder: user.label,
            idutente: user.value,
        };

        return this.http.post(url, JSON.stringify(body), { headers: headers }).map((responseData) => responseData.json());
    }

    deleteUser(srmToken, reforder: string, idutente: number): Observable<BaseResponse> {
        let url = environment.REST_SERVICE_BASE_URL + '/offers/deleteuser/' + idutente + '/' + reforder;
        url = AppConstants.urlForNoCache(url);

        const headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
        return this.http.delete(url, { headers: headers }).map((responseData) => responseData.json());
    }

    getOreAttivita(srmToken: string, reforder: string): Observable<BaseResponse> {
        var url = environment.REST_SERVICE_BASE_URL + '/offers/stats';
        url = AppConstants.urlForNoCache(url);
        var headers = new Headers();
        headers.append(AppConstants.SRM_TOKEN_NAME, srmToken);
        let params: URLSearchParams = new URLSearchParams();
        params.set("reforder", reforder);

        return this.http.get(url, { search: params, headers: headers }).map((responseData) => responseData.json());
    }

    private checkString(value: string | null | undefined): boolean {
        if (value !== null && value !== undefined && value.trim() !== '') {
            if (value == "S") {
                return true;
            }
            return false;
        }
        return null;
    }
}



// WEBPACK FOOTER //
// ./src/app/service/offers.service.ts